export default "__VITE_ASSET__4IZC8OYU__"